import React from "react";
import emmaImg from "../../Assets/Images/emmaCoolinsImg.png";

const WhatOurClientsSay = () => {
  return (
    <div className="container">
      <div className="what-our-clients-say">
        <h1 className="clients-title">What Our Clients Say</h1>
        <div className="row what-our-clients-say-section">
          <div className="col-lg-3 d-flex justify-content-center">
            <img src={emmaImg} alt="Emma Collins" className="client-img" />
          </div>
          <div className="col-lg-9 client-text">
            <p>
                The team made our ISO 9001 certification process seamless and
                efficient. Their expertise and guidance saved us time and ensured
                success. They were always available to answer our questions and
                provided clear, practical advice. We now feel confident in our
                systems and proud of our certification. Their professionalism and
                dedication exceeded our expectations. We look forward to working
                with them on future certifications.
            </p>
            <h6>
              <b>Emma Collins</b> – Operations Manager,{" "}
              <b>PrimeTech Solutions</b>
            </h6>

            {/* Dots inside container */}
            <div className="dots-container">
              <span className="dot active"></span>
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatOurClientsSay;
